/**
 * A document as readable Markdown WITHOUT the editor (git sync Stage 2,
 * S2.1) — for reading only: MCP `document_read`. It uses the same writer as
 * the git converter, so italic stays italic, nested lists stay nested and
 * tables stay tables (the old regex converter got all three wrong), but it
 * skips the read-back check, which needs the headless editor and its node
 * classes — modules the MCP import graph must not reach.
 *
 * It NEVER writes the JSON fallback: that is the editor's internal data, and
 * it must not leave the app over MCP. A block it cannot write makes it throw;
 * the caller then reads the document's HTML instead.
 *
 * Writing to git uses index.js (exact, verified); never this.
 */
import { blockToMarkdown, joinBlocks } from './blocksToMarkdown';
import { withDefaults, childrenOf } from './ctx';

const KNOWN = new Set(['paragraph', 'heading', 'quote', 'callout', 'list', 'code', 'table', 'doc-image', 'doc-video', 'page-link']);

/** @param {object|Array} input  a block snapshot ({version, blocks}) or root children */
export function documentToReadableMarkdown(input, rawCtx = {}) {
  const nodes = childrenOf(input);
  const ctx = withDefaults(rawCtx, nodes);
  const parts = nodes.map((n) => {
    if (!n || !KNOWN.has(n.type)) throw new Error(`no readable form for a "${n && n.type}" block`);
    return blockToMarkdown(n, ctx);
  });
  return `${joinBlocks(nodes, parts)}\n`;
}
